import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { I18n } from 'react-redux-i18n-lite';
import CustomIcon from '../CustomIcon';
import { SmartButton } from '../../common/SmartButton';
import * as contentActions from '../../../actions/contentActions';

import BookDownloadBar from '../../book/BookDownloadBar/BookDownloadBar';
import dayjs from 'dayjs';
import * as _ from 'lodash';
import { BOOK_DOWNLOADING_STATUS, CONTENT_SYNCHRONIZATION_STATUS, CDN_SYNCHRONIZATION_STATUS } from '../../../const';
import { isContentBookDownloadingOrUnzipping } from '../../../utils/contentUtils';

export class DownloadBookDropDown extends React.Component {
  state = { open: false };

  static propTypes = {
    pathname: PropTypes.string,
    content: PropTypes.object,
    colors: PropTypes.object,
    contentActions: PropTypes.object,
    userId: PropTypes.string,
    isAppOnline: PropTypes.any
  };

  handlerClick = () => {
    const { open } = this.state;
    this.setState({ open: !open });
  };

  handlerClose = () => {
    this.setState({ open: false });
  };

  isDownloadOnPause = contentBook => {
    return contentBook.status === BOOK_DOWNLOADING_STATUS.PAUSE;
  };

  handleSwitchDownloadButton = contentBook => {
    const { contentActions } = this.props;

    if (this.isDownloadOnPause(contentBook)) {
      contentActions.saveBook(contentBook.classId, contentBook, contentBook.bookName);
    } else {
      contentActions.updateContentBookStatus(BOOK_DOWNLOADING_STATUS.PAUSE, contentBook.id, contentBook.classId);
    }
  };

  handleCancelDownload = contentBook => {
    const { contentActions, userId } = this.props;

    localStorage.removeItem(`saveBook_${contentBook.bookId}`);
    contentActions.cancelBookDownload(contentBook, userId);
  };

  isDownloadingOrSynchronizing = () => {
    const { content } = this.props;
    let result = false;

    if (
      content.contentSynchronizationStatus === CONTENT_SYNCHRONIZATION_STATUS.SYNCHRONIZING ||
      content.cdnSynchronizationStatus === CDN_SYNCHRONIZATION_STATUS.SYNCHRONIZING
    ) {
      result = true;
    }

    const contents = _.filter(content.contentBooks, contentBook => {
      const isDownloading = contentBook.status === BOOK_DOWNLOADING_STATUS.DOWNLOADING;
      const isUnzipping = contentBook.status === BOOK_DOWNLOADING_STATUS.UNZIPPING;
      return isDownloading || isUnzipping || contentBook.isSynchronizing;
    });

    result = contents && contents.length ? true : result;

    return result;
  };

  isUnzipping = () => {
    const { content } = this.props;

    const filterUnzipping = _.filter(
      content.contentBooks,
      contentBook => contentBook.status === BOOK_DOWNLOADING_STATUS.UNZIPPING
    );
    return filterUnzipping.length;
  };

  renderSyncManagerContent = () => {
    const { contentActions, userId, content } = this.props;
    let lastSync = content.contentSynchronizationDate;
    return (
      <div className="no-active-downloads-content">
        <div className="header">{I18n.t('common.noActiveDownloads')}</div>
        <div className="last-sync">{`${I18n.t('common.lastSynchronization')}: ${dayjs(lastSync).format('L')}`}</div>
        <SmartButton
          success
          onClick={() => {
            contentActions.synchronizeContentDownload(userId, true);
          }}
        >
          {I18n.t('common.synchronize')}
        </SmartButton>
      </div>
    );
  };

  renderDownloadManagerContent = () => {
    const { content } = this.props;

    let booksDownloading = [];

    booksDownloading.push(
      <div className="header" key="header">
        {content.contentSynchronizationStatus === CONTENT_SYNCHRONIZATION_STATUS.SYNCHRONIZING
          ? I18n.t('common.synchronizing')
          : this.isUnzipping()
          ? I18n.t('common.unzipping')
          : I18n.t('common.downloading')}
      </div>
    );

    let contentBooks = content.contentBooks;
    contentBooks = _.sortBy(contentBooks, ['bookId', 'classId']);

    contentBooks.forEach((contentBook, index) => {
      let pauseRestartIcon = 'video-player-pause-button';
      if (this.isDownloadOnPause(contentBook)) {
        pauseRestartIcon = 'multimedia-music-player-play-button';
      }
      if (
        isContentBookDownloadingOrUnzipping(contentBook) ||
        this.isDownloadOnPause(contentBook) ||
        contentBook.isSynchronizing
      ) {
        booksDownloading.push(
          <div className="progress-book" key={`book-${index}`}>
            <span>{contentBook.bookName}</span>
            <div>
              <div className="manage-book-downloads-container">
                <BookDownloadBar
                  handlePauseRestart={() => {
                    this.handleSwitchDownloadButton(contentBook);
                  }}
                  handleCancel={() => {
                    this.handleCancelDownload(contentBook);
                  }}
                  bookId={contentBook.id}
                  classId={contentBook.classId}
                  wrapperClassName={'round-border'}
                  pauseRestartIcon={pauseRestartIcon}
                  showButtons={contentBook.status !== BOOK_DOWNLOADING_STATUS.UNZIPPING}
                />
              </div>
            </div>
          </div>
        );
      }
    });

    if (booksDownloading.length > 1) return booksDownloading;
    return this.renderSyncManagerContent();
  };

  renderContent = () => {
    return <div className="download-book-drop-down">{this.renderDownloadManagerContent()}</div>;
  };

  render() {
    const { isAppOnline } = this.props;
    const { open } = this.state;
    let showLarge = open ? 'show-large' : '';
    let show = open ? 'show' : '';
    let content = this.renderContent();

    let classNameDisabled = '';
    let rotatingOnClick = this.handlerClick;
    if (!isAppOnline) {
      classNameDisabled = 'disabled';
      rotatingOnClick = '';
    }

    return (
      <div>
        <div
          className={`custom-drop-down-options float-right process-icon ${classNameDisabled}`}
          onBlur={this.handlerClose}
          tabIndex="-1"
        >
          <div className={`options-drop-down-pane ${classNameDisabled}`} onClick={rotatingOnClick}>
            {
              <CustomIcon
                classes={`${this.isDownloadingOrSynchronizing() ? 'rotating' : ''} icon`}
                name="synchronize"
                size={18}
              />
            }
          </div>
          <div className={`custom-drop-down-pane down ${showLarge}`}>
            <div className={`custom-drop-down-pane-content ${show}`}>{content}</div>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    colors: state.theme.colors,
    content: state.content,
    userId: state.account.user._id,
    isAppOnline: state.connection.status.online
  };
}

function mapDispatchToProps(dispatch) {
  return {
    contentActions: bindActionCreators(contentActions, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(DownloadBookDropDown);
